module.exports = __webpack_public_path__ + "img/26.235c1dda.png";